// extracted by mini-css-extract-plugin
export default {"background":"_1MGj2","circle":"_3KMOz","skeleton":"_1YvB2","button":"_2pPEb","top":"_35IRE","star":"_2WOJ4","roundStar":"_3XHbM"};